import { Component, ElementRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { pwaInstallHandler } from 'pwa-install-handler'
import '@khmyznikov/pwa-install';

@Component({
  selector: 'app-pwa-installer',
  standalone: false,
  templateUrl: './pwa-installer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './pwa-installer.component.scss',
})
export class PwaInstallerComponent {
  @ViewChild('pwaInstall') pwaInstall!: ElementRef;
  public name = 'ZGrane Gronoo';

  install(): void {
    
    this.pwaInstall.nativeElement

    if (pwaInstallHandler.canInstall()) {
      pwaInstallHandler.install();
    } else {
      this.pwaInstall.nativeElement.showDialog(true);
    }
  }

  public eventHandle = (event: any) => {
    console.log(event);
  };
}
